<template>
  <v-footer color="teal" inset absolute app class="d-block" height="auto">
    <v-card
      flat
      tile
      class="deep-purple darken-1 white--text text-xs-center"
    >
      <v-card-text>
        <v-btn
          v-for="icon in icons"
          :key="icon"
          icon
          class="mx-3 white--text"
        >
          <v-icon size="24px">{{ icon }}</v-icon>
        </v-btn>
      </v-card-text>
      <v-card-text class="white--text">
        Carano diseños &amp; marketing - Paginas Web - Argentina - © 2018
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
  export default {
    data: () => ({
      icons: ['fab fa-facebook', 'fab fa-google-plus', 'fab fa-instagram']
    })
  }
</script>



// WEBPACK FOOTER //
// src/components/page_structure/Footer.vue